import { Breadcrumb, ErrorEvent, init, browserTracingIntegration, replayIntegration } from '@sentry/angular';
import { environment } from '@env/environment';

export function initSentry(): void {
  init({
    release: environment.version, // TODO: auto-refresh project version
    dsn: environment.sentry.DSN,
    allowUrls: [
      window.location.origin, // skip errors from external libraries and browser extensions
    ],
    denyUrls: ['fbstest1.com', 'fbstest2.com'],
    ignoreErrors: [
      'Non-Error exception captured',
      '404',
    ],
    beforeSend(event: ErrorEvent) {
      if (/Loading chunk [\d]+ failed/.test(event.message)) {
        window.location.reload();
      }

      event.tags = {
        ...event.tags,
        is_pwa: detectPwa(),
      }

      return event;
    },
    beforeBreadcrumb(breadcrumb: Breadcrumb): Breadcrumb | null {
      switch (breadcrumb.category) {
        case 'xhr':
        case 'fetch':
          return null;
        default:
          return breadcrumb;
      }
    },

    integrations: [
      browserTracingIntegration(),
      replayIntegration(),
    ],
    sampleRate: .5,
    tracesSampleRate: .1,
    replaysSessionSampleRate: .01,
    replaysOnErrorSampleRate: .5,
  });
}

function detectPwa(): boolean {
  return typeof window !== 'undefined' &&
    window.matchMedia('(display-mode: standalone)')?.matches;
}
